export const StorageIdUser = 'USER';
export const StorageIdUserAccess = 'USER_ACCESS';
export const DEVICE_CURRENT_PROFILE = 'DEVICE_CURRENT_PROFILE';
export const APP_SETTINGS = 'appSettings';
export const DEVICES = 'DEVICES';
export const VIRTUAL_DEVICE = 'VIRTUAL_DEVICE';
export const VIRTUAL_DEVICE_ID = 'VIRTUAL_DEVICE_ID';
export const VIRTUAL_DEVICE_TOKEN = 'VIRTUAL_DEVICE_TOKEN';
